var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from 'grommet';
import { PlanHeader } from './PlanHeader';
import { PlanBody } from './PlanBody';
import { PlanFooter } from './PlanFooter';
export var PlanCard = function (_a) {
    var name = _a.name, features = _a.features, price = _a.price, _b = _a.highlight, highlight = _b === void 0 ? false : _b, description = _a.description, _c = _a.buttonProps, buttonProps = _c === void 0 ? {} : _c, rest = __rest(_a, ["name", "features", "price", "highlight", "description", "buttonProps"]);
    return (_jsxs(Card, __assign({ background: highlight ? "brand" : "background-front" }, rest, { children: [_jsx(PlanHeader, { highlight: highlight, title: name, price: price || 0, subtitle: description || "" }), _jsx(PlanBody, { highlight: highlight, features: features }), _jsx(PlanFooter, { highlight: highlight, buttonProps: buttonProps })] })));
};
PlanCard.defaultProps = {
    buttonProps: {},
    description: "",
    highlight: false,
};
//# sourceMappingURL=PlanCard.js.map